<template>
  <div>
    <UButton label="Refresh" @click="refreshAccounts" />
    <UTable :loading="loading" :rows="accounts" class="py-2" />
  </div>
</template>

<script setup>
import { ref } from "vue";
const app = useAppConfig();
const toast = useToast();

const accounts = ref([]);
const loading = ref(false);
let initialized = false;

const refreshAccounts = () => {
  loading.value = true;
  $fetch(app.service + "/portfolios")
    .then((data) => {
      loading.value = false;
      accounts.value = data;
      if (initialized) {
        toast.add({ title: "Portfolios refreshed", timeout: 2000 });
      }
      initialized = true;
    })
    .catch(() => (loading.value = false));
};

onMounted(() => {
  refreshAccounts();
});
</script>
